<template>
  <Wrapper :no-header="true">
    <GameSummary
      :team-a="teamAData"
      :team-b="teamBData"
      :winner="winner"
    />

    <template slot="footer">
      <button
        class="btn btnPrimary"
        @click="$_redirectWithSound({ name: 'game' })"
      >
        {{ $t('views.summary.play_again') }}
      </button>
      <button @click="$_redirectWithSound({ name: 'setup' })">
        {{ $t('views.summary.new_game') }}
      </button>
    </template>
  </Wrapper>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Wrapper from '@/components/Wrapper/Wrapper';
import GameSummary from '@/components/GameSummary/GameSummary';
import { teamA } from '@/consts';

export default {
  components: {
    Wrapper,
    GameSummary,
  },

  computed: {
    ...mapGetters('game', [
      'winner',
    ]),

    ...mapState('game', [
      'teamA',
      'teamB',
    ]),

    ...mapState('settings', [
      'teamAEmoji',
      'teamBEmoji',
    ]),

    hasTeamAWon() {
      return this.winner === teamA;
    },

    teamAData() {
      return {
        ...this.teamA,
        emoji: this.teamAEmoji,
      };
    },

    teamBData() {
      return {
        ...this.teamB,
        emoji: this.teamBEmoji,
      };
    },
  },

  created() {
    this.$_playSound('hooray');
  },
};
</script>
